import ElementDialog from "./src/index.vue";

ElementDialog.install = function(Vue) {
  Vue.component(ElementDialog.name, ElementDialog);
};

export default ElementDialog;
